import { render, staticRenderFns } from "./dpWalletRecord.vue?vue&type=template&id=42b6bd6c&scoped=true&"
import script from "./dpWalletRecord.vue?vue&type=script&lang=js&"
export * from "./dpWalletRecord.vue?vue&type=script&lang=js&"
import style0 from "./dpWalletRecord.vue?vue&type=style&index=0&id=42b6bd6c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b6bd6c",
  null
  
)

export default component.exports